import { NetworkResponse } from '../../../@packages/dataFetch';
import { isUndefined } from '../../../predicates/type';
import { POST_NETWORK_USAGE_EVENT_NAME } from './const';

function sendPOSTUsageAnalytics({
	requestUrl,
	requestModuleName,
	data,
}: {
	requestUrl: string;
	requestModuleName?: string;
	data?: unknown;
}) {
	const analyticsData = {
		event: POST_NETWORK_USAGE_EVENT_NAME,
		requestUrl,
		requestModuleName,
	};

	if (!isUndefined(data)) {
		analyticsData['data'] = data;
	}

	window.dataLayer.push(analyticsData);
}

function getUrlModuleName(url: string) {
	const urlMatch = url.match(/^\/.*?\//);

	if (urlMatch === null) {
		return;
	}

	return urlMatch[0].slice(1, -1);
}

function handlePOSTRequest(response: NetworkResponse) {
	const requestUrl = response.config.url;
	const requestModuleName = getUrlModuleName(requestUrl);
	const rawData = response.config?.data;
	let parsedData: unknown;

	try {
		parsedData = JSON.parse(rawData);
	} catch (e) {
		console.warn(`No data to log by url: ${requestUrl}`);
	}

	sendPOSTUsageAnalytics({
		requestUrl,
		requestModuleName,
		data: parsedData,
	});
}

export { getUrlModuleName, handlePOSTRequest };
